var _desc, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "local_cafe icon - Licensed under Apache License v2.0 (http://www.apache.org/licenses/LICENSE-2.0) - Created with Iconfu.com - Derivative work of Material icons (Copyright Google Inc.)")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5168 0 0 1.5168 -226.27 -226.94)",
    fill: "#dda479",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m151.51 516.83v-301.87c0-33.93 27.51-61.44 61.44-61.44h474.66c121.6 0 136.54 60.91 136.54 136.53v73.415c0 111.85-29.443 136.54-136.54 136.54h-13.65v16.827c0 176.37-160.02 206.41-262.54 206.41s-259.92-36.022-259.92-206.41zm536.1-301.87h-474.66v292.64c0 104.99 85.865 154.14 198.06 154.14s201.52-39.824 201.52-155.38v-67.791h75.09c41.68 0 75.1-33.42 75.1-75.1v-73.415c0-41.68-33.42-75.09-75.1-75.09zm-10.549 148.5h-64.541v-73.415h64.541z",
    fill: "#dda479"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m46.183 975.96h725.87",
    fill: "#fff",
    stroke: "#dda479",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 93.46
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/icon_support.1ec014abfadf9bad769d76508165473c.svg";
export { ForwardRef as ReactComponent };